import { supabase } from '../lib/supabase'

/**
 * Configuración SMTP (fila única id=1) usada por la Edge Function para enviar
 * los correos de alertas de tickets. Tabla: Tickets.smtpConfig.
 * @namespace smtpConfigService
 */
const smtpConfigService = {
  schemaName: 'Tickets',
  tableName: 'smtpConfig',

  async get() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
        .eq('id', 1)
        .maybeSingle()
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error fetching SMTP config:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  /**
   * Guarda la configuración (upsert de la fila única).
   * @param {Object} config - { host, port, username, password, fromEmail, fromName, secure, active }
   */
  async save(config) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .upsert(
          { id: 1, ...config, updatedAt: new Date().toISOString() },
          { onConflict: 'id' }
        )
      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error saving SMTP config:', error)
      return { success: false, error: error.message }
    }
  },
}

export default smtpConfigService
